import { ExternalDocumentPacketExportReason } from 'primary-schema';
import { z } from 'zod';

import { isDefined } from '../../../utils.js';

/** Mirrors `hasDirectoryTraversal` in notable-common, which the web workspace cannot resolve. */
export function hasDirectoryTraversal(filePath: string | undefined): boolean {
  return isDefined(filePath) && filePath.split(/[/\\]/).includes('..');
}

export const ExportExternalDocumentPacketBlockConfigSchema = z.object({
  externalDocumentPacket: z.object({
    sourceBlockName: z.string(),
  }),
  exportReason: z.enum(ExternalDocumentPacketExportReason),
  filePath: z
    .string()
    .optional()
    .refine((filePath) => !hasDirectoryTraversal(filePath), {
      message: 'Directory traversal attempts (..) are not allowed in file paths',
    }),
});

export type ExportExternalDocumentPacketBlockConfig = z.infer<
  typeof ExportExternalDocumentPacketBlockConfigSchema
>;
